import { Injectable } from "@angular/core";
import { ProjectSelectors } from "@app/project/store/selectors";
import { EffectsUtils } from "@app/root-store/effects/effect-creators";
import { ActionWord } from "@app/shared/resources/action-word";
import { checkCurrentID } from "@app/shared/resources/data-actions";
import { Actions } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { map } from "rxjs/operators";
import { CHRulesDbService } from "../../services/ch-rules-db.service";
import { CommandActions } from "../actions";

@Injectable()
export class CommandEffects extends EffectsUtils {
    constructor(actions$: Actions, private readonly ruleService: CHRulesDbService, private readonly store: Store) {
        super(actions$);
    }

    getCommands$ = this.createSwitchEffect({
        dbMethod: ({ uuid }) =>
            this.ruleService.getCommands(uuid).pipe(
                checkCurrentID(this.store.pipe(select(ProjectSelectors.getUuid)), uuid),
                map(commands => ({ uuid, commands }))
            ),
        actionSet: CommandActions.loadSet,
    });

    getSceneCommandsFailure$ = this.createFailureEffect(CommandActions.loadSet.failure, ActionWord.retrieved, null, "Error getting scenes");
}
